const SubjectDictionary = new Map([
  ['english', '영어'], 
  ['math', '수학']
]); 

export default SubjectDictionary